/**
 * Retorna duas datas:
 * 1) Primeiro dia do mês da data de hoje.
 * 2) Primeiro dia do mês seguinte à data obtida somando 45 dias a hoje.
 */
export function getBoundaryDates45(): { start: string; end: string } {
	const today = new Date();

	// 1) Primeiro dia do mês de hoje
	const firstOfThisMonth = new Date(today.getFullYear(), today.getMonth(), 1);

	// 2) Data daqui a 45 dias
	const future = new Date(today);
	future.setDate(future.getDate() + 45);

	// Primeiro dia do mês seguinte ao mês de 'future'
	const firstOfNextMonthOfFuture = new Date(
		future.getFullYear(),
		future.getMonth() + 1,
		1
	);

	// Formata em "YYYY-MM-DD"
	const fmt = (d: Date) =>
		`${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(
			d.getDate()
		).padStart(2, '0')}`;

	return {
		start: fmt(firstOfThisMonth),
		end: fmt(firstOfNextMonthOfFuture),
	};
}
